import { useContext } from 'react'
import { Divider, Flex } from '@chakra-ui/react'
import { UserContext } from 'features/Auth/context/user.context'
import { LeftAside } from 'components/Layout/LeftAside'
import { RightAside } from 'components/Layout/RightAside'
import { Left, Right } from './routes'

export const Settings = () => {
  const { engineer } = useContext(UserContext)
  return (
    <Flex justifyContent='center' height='100%'>
      <LeftAside>
        <Left engineer={engineer} />
      </LeftAside>
      <Divider
        height='100vh'
        variant='dashed'
        orientation='vertical'
        size='1px'
      />
      <RightAside>
        <Right engineer={engineer} />
      </RightAside>
    </Flex>
  )
}
